import { IgenomicsAction } from '../../../core/interfaces/genomics-action.interface';
import * as immutable from 'immutable';
import { IAnnotationSearchableLink } from '../../aberrations/interfaces/annotation-searchable-links.interface';
import { ABERRATIONS_META_ACTIONS } from '../constants/aberrations-meta.constants';


export interface IAbberationsMetaState {
    config: {
        searchableLinks: immutable.Map<string, immutable.List<IAnnotationSearchableLink>>;
    };
}

const InitTestMetaState: IAbberationsMetaState = {
    config: {
        searchableLinks: immutable.Map<string, immutable.List<IAnnotationSearchableLink>>()
    }
};

export function aberrationsMetaReducer(state: IAbberationsMetaState = InitTestMetaState, action: IgenomicsAction): IAbberationsMetaState {
    let newState;
    switch (action.type) {
        case ABERRATIONS_META_ACTIONS.SET_SEARCH_LINK_CONFIG:
            newState = Object.assign({ }, state);
            newState.config = Object.assign({ }, newState.config);
            newState.config.searchableLinks = newState.config.searchableLinks.set(action.payload['searchId'], action.payload['config']);
            return newState;
        default:
            return state;
    }
}
